import React from 'react';
import { BOARD_CREATE_COLUMN_NUDGE_ID } from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { OnboardingNudgeErrorBoundary } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/onboarding-nudge-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { ERROR_BOUNDARY_ID_KANBAN_TOUR_NUDGE } from '../../../common/constants.tsx';
import type { WrapperProps } from '../../../common/types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const BoardCreateColumnNudgeLazy = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-software-kanban-onboarding-board-create-column-nudge" */ './index'
		).then((exportedModule) => exportedModule.BoardCreateColumnNudge),
	{
		ssr: false,
	},
);

export const BoardCreateColumnKanbanTourNudgeAsync = ({ children }: WrapperProps) => (
	<OnboardingNudgeErrorBoundary
		id={ERROR_BOUNDARY_ID_KANBAN_TOUR_NUDGE}
		fallback={children}
		attributes={{
			nudgeId: BOARD_CREATE_COLUMN_NUDGE_ID,
		}}
	>
		<Placeholder name="software-kanban-onboarding-board-create-column-nudge" fallback={children}>
			<BoardCreateColumnNudgeLazy>{children}</BoardCreateColumnNudgeLazy>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);

BoardCreateColumnKanbanTourNudgeAsync.displayName = 'BoardCreateColumnKanbanTourNudgeAsync';
